import pixAxios from '@/axios/pixAxios.js';
import Console from '@/shared/console';
import certificationProvider from '@/apiProviders/certification.provider';

const certificationModule = {
  namespaced: true,
  state: {
    certificationSection: null,
    newCertification: null,
  },
  actions: {
    async fetchCertificationSection({ state, commit, rootGetters }, data) {
      commit('setcertificationSection', null);
      try {
        const params = {
          ...data,
          InstanceRol: rootGetters['authModule/fullInstance'],
        };

        const { total, rows, nSkip } = await certificationProvider.searchCertificationSection(params);
        commit('setcertificationSection', rows);
        return { total, rows, nSkip };
      } catch (error) {
        Console.log(error.response);
      }
    },

    setNewCertification({ state, commit }, data) {
      commit('setNewCertification', data);
    },
  },

  mutations: {
    setcertificationSection(state, certification) {
      state.certificationSection = certification;
    },

    setNewCertification(state, newCertification) {
      state.newCertification = newCertification;
    },
  },

  getters: {
    getcertificationSection(state) {
      return state.certificationSection;
    },

    getNewCertification(state) {
      return state.newCertification;
    },
  },
};

export default certificationModule;
